module.exports = __webpack_public_path__ + "static/media/accessory_01.75ad3a0e.jpg";